"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IBehaviour_1 = require("./IBehaviour");
exports.IBehaviour = IBehaviour_1.IBehaviour;
